export default "__VITE_ASSET__DRW3otz4__"